import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthenticationService } from './services/authentication/authentication.service';
import { ThemeService } from './services/theme/theme.service';
import { Storage } from '@ionic/storage-angular';
import { SseService } from './services/sse.service';
import { ConfigService } from './services/config/config.service';
import { ProcessService } from './services/process/process.service';
import { UploadService } from './services/upload_service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

const themes = {
  defaults: {
    primary: '#3880ff',
    secondary: '#0cd1e8',
    tertiary: '#7044ff',
    success: '#10dc60',
    warning: '#ffce00',
    danger: '#f04141',
    dark: '#222428',
    medium: '#989aa2',
    light: '#ffffff',
  },
  // Add other themes here...
};

const TOKEN_KEY = 'auth-token';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  public changePasswordPage = false;
  public baseUrl: string | undefined;
  private hasNavigated = false;
  private authSub!: Subscription;
  private focusListener!: () => void;
  private alertPresented = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private theme: ThemeService,
    private storage: Storage,
    public alertCtrl: AlertController,
    private sseService: SseService,
    private configService: ConfigService,
    private processService: ProcessService,
    private uploadService: UploadService,
    private authenticationService: AuthenticationService,
  ) {
    var thiss = this
    this.changeTheme('defaults');
    window.addEventListener('focus', () => {
      thiss.storage.get(TOKEN_KEY).then(res => {
        if (!res) {
          thiss.authenticationService.logout()
        } else {
          if (window.location.pathname == '/login') {
            thiss.authenticationService.authStateSet()
            // thiss.router.navigate(['app', 'dashboard']);
          }
        }
      });
    });

    this.authenticationService.authenticationState.subscribe(state => {
      console.log("App", state)
      this.changePasswordPage = false;
      if (window && "location" in window
        && "protocol" in window.location
        && "pathname" in window.location
        && "host" in window.location) {
        if (window.location.href.toString().includes('changePassword')) {
          this.changePasswordPage = true;
        }
      }
      if (state && !this.changePasswordPage) {
        this.subscribeToSSE()
        if (window.location.pathname.split('/').pop() != 'Inventory%20Manager') {
          this.router.navigate(['app', 'dashboard']);
        } else {
          this.redirectToAction()
        }
      } else if (!this.changePasswordPage) {
        this.router.navigate(['login']);
      }
    });
  }

  async ngOnInit() {
    if (window.location.pathname.includes('actionsWindow')) {
      this.router.navigateByUrl('/app/dashboard', { replaceUrl: true });
    }
  }

  ngOnDestroy() {
    // this.authSub?.unsubscribe();
    // window.removeEventListener('focus', this.focusListener);
  }

  private async handleAuthState(state: boolean) {
    // this.changePasswordPage = this.router.url.includes('changePassword');
    // if (this.hasNavigated) return; // Prevent infinite navigation
    // if (state && !this.changePasswordPage) {
    //   this.subscribeToSSE();
    //   this.router.navigate(['/app/dashboard']);
    // } else if (!state && !this.changePasswordPage) {
    //   this.router.navigate(['/login']);
    // }
    // this.hasNavigated = true;
  }

  private async checkTokenOnFocus() {
    const token = await this.storage.get(TOKEN_KEY);
    if (!token) {
      this.authService.logout();
    } else if (this.router.url === '/login') {
      this.authService.authStateSet();
    }
  }

  changeTheme(name: string) {
    if (themes[name]) {
      //this.theme.setTheme(themes[name]);
    }
  }

  async subscribeToSSE() {
    const userData: any = await this.storage.get('userData');
    if (!userData) return;

    const checkForScreenLock = userData.departmentName === 'KAM Sales';
    const baseUrl = await this.configService.getBaseUrl();

    this.sseService
      .getServerSentEvent(
        `${baseUrl}master-service/api/sse/subscribe?userId=${userData.userId}&checkForScreenLock=${checkForScreenLock}`,
        userData.userId,
      )
      .subscribe((data) => this.handleSSEEvent(data));
  }

  private handleSSEEvent(data: any) {
    switch (data.type) {
      case 'message':
        this.manageNotification(data);
        break;
      case 'lock':
        this.lockPopup(data);
        break;
      case 'user-disabled':
        this.authService.logout();
        break;
      case 'TemplateDownload':
        this.openTemplate(data);
        this.manageNotification(data);
        break;
    }
  }

  private async manageNotification(data: any) {
    // Simplified: only show browser notification if granted
    if (!('Notification' in window)) return;

    if (Notification.permission === 'granted') {
      new Notification(data.data || 'New notification', {
        requireInteraction: true,
      });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission();
    }
  }

  private async openTemplate(data: any) {
    const baseUrl = await this.configService.getBaseUrl();
    const url = data.data?.includes('.com') ? data.data : baseUrl + data.data;
    if (document.visibilityState === 'visible') window.open(url, '_blank');
  }

  private async lockPopup(data: any) {
    const listOfActions = await this.storage.get('listOfActions');
    const actionExist = listOfActions?.find(
      (a: any) => a.actionName === 'Inventory Manager',
    );
    if (!actionExist || this.alertPresented) return;

    this.alertPresented = true;
    const alert = await this.alertCtrl.create({
      header: 'Warning!',
      message:
        'Please go to incoming tab of Inventory Manager action and receive incoming stones first.',
      backdropDismiss: true,
      cssClass: 'alertModal',
      buttons: [
        {
          text: 'Go To Inventory Manager',
          handler: () => {
            window.open(
              `${window.location.origin}/app/dashboard/Inventory Manager`,
              '_blank',
            );
            this.alertCtrl.dismiss();
          },
        },
      ],
    });
    await alert.present();
  }

  async redirectToAction() {
    let listOfActions = await this.storage.get("listOfActions")
    if (!!listOfActions) {
      let actionExist = listOfActions.find(action => action.actionName == 'Inventory Manager');
      if (actionExist) {
        this.processService.setActionName(
          actionExist.actionName,
          actionExist.id,
          actionExist.voucherType,
          actionExist.listOfActionPermissions,
        );
        setTimeout(() => {
          this.router.navigate(['app', 'actionsWindow'])
        }, 500)
      }
    }
  }
}
